var React = require('react');

function LockIconInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6.08751","y":"1.42332","width":"7.11539","height":"11.3846","rx":"2.84615","fill":"white","stroke":"#7F7F7F","strokeWidth":"2.84615","key":0}),React.createElement("rect",{"x":"0.392822","y":"8.53824","width":"18.5","height":"11.3846","rx":"1.10684","fill":"#7F7F7F","key":1}),React.createElement("rect",{"x":"7.5094","y":"11.3853","width":"2.84615","height":"5.69231","rx":"1.42308","fill":"white","key":2})]);
}

LockIconInline.defaultProps = {"width":"19","height":"20","viewBox":"0 0 19 20","fill":"none"};

module.exports = LockIconInline;

LockIconInline.default = LockIconInline;
